const zhCN = {
  listVisitorName: '姓名',
  listVisitorPhone: '电话',
  listLicensePlate: '车牌号',
  listInviter: '邀请人',
  listInviterOrg: '邀请人组织',
  listAppointmentTime: '预约时间',
  listIsVisited: '是否到访',
  state: '审核状态',
  listVisited: '已到访',
  listWaitting: '未到访',
  listOverdue: '未到访',
  listOperation: '操作',

  stateWaiting: '待审核',
  statePass: '审核通过',
  stateRefuse: '审核拒绝',
  stateDelete: '已删除',

  listDetailBtn: '详情',

  visitorSettingsBtn: '访客设置',

  validStartTimeTxt: '预约时间',
  validEndTimeTxt: '预约时间',
  aWeekBeforeBtn: '前一周',
  oneMonthBeforeBtn: '前一个月',
  threeMonthsBeforeBtn: '前三个月',

  visitorOrgTxt: '所属机构',

  visitorOrInviterName: '访客或邀请人姓名',
  visitorApproveState: '审核状态',
  searchBtn: '搜索',

  exportBtn: '导出',

  getVisitorInfoFail: '获取预约访客记录失败！',

  getVisitorDetailFail: '获取预约访客详情失败！',

  modalReservationRecordDetail: '预约记录详情',

  mReservedVisitorTitle: '访客信息',
  mReservedPhoto: '预约现场照',
  mName: '访客姓名',
  mPhone: '手机号码',
  mCardType: '证件类型',
  mLicense: '车牌号',
  mIDNumber: '证件号码',

  mReserveApplicationTitle: '预约申请信息',
  mIName: '邀请人',
  mIOrg: '邀请人组织',
  mReservedRange: '预约时间',
  mVisitReason: '来访事由',
  mRemark: '备注',

  mCompanionTitle: '同行访客',
  mSignInPhoto: '到访签到照',
  mSignInAt: '签到时间',
  mSignInDevice: '签到设备',
  mSignOutAt: '签离时间',
  mSignOutDevice: '签离设备',

  exportFilePrefix: '预约记录',
  exportSuccess: '导出成功！'
}
const enUS = {
  listVisitorName: 'Name',
  listVisitorPhone: 'Phone',
  listLicensePlate: 'License Plate',
  listInviter: 'Inviter',
  listInviterOrg: 'Inviter Org',
  listAppointmentTime: 'Appointment Time',
  listIsVisited: 'Visited',
  state: 'State',
  listVisited: 'Visited',
  listWaitting: 'Waitting',
  listOverdue: 'Overdue',
  listOperation: 'Operation',

  stateWaiting: 'Waiting',
  statePass: 'Pass',
  stateRefuse: 'Refuse',
  stateDelete: 'Deleted',

  listDetailBtn: 'Detail',

  visitorSettingsBtn: 'Visitor Settings',

  validStartTimeTxt: 'Appointment Time',
  validEndTimeTxt: 'Appointment Time',
  aWeekBeforeBtn: 'a week before',
  oneMonthBeforeBtn: 'one month before',
  threeMonthsBeforeBtn: 'three months before',

  visitorOrgTxt: 'Visitor Organization',

  visitorOrInviterName: 'Visitor / Inviter Name',

  visitorApproveState: 'Approve State',

  searchBtn: 'Search',

  exportBtn: 'Export',

  getVisitorInfoFail: 'Get the reservation visitor record failed!',

  getVisitorDetailFail: 'Get visitor details failed!',

  modalReservationRecordDetail: 'Reservation Record Detail',

  mReservedVisitorTitle: 'Reservation Visitor',
  mReservedPhoto: 'Reservation Photo',
  mName: 'Name',
  mPhone: 'Phone',
  mCardType: 'ID Type',
  mLicense: 'License Plate',
  mIDNumber: 'ID Number',

  mReserveApplicationTitle: 'Reservation Application',
  mIName: 'Inviter',
  mIOrg: 'Inviter Org',
  mReservedRange: 'Visiting Period',
  mVisitReason: 'Visiting Reason',
  mRemark: 'Remark',

  mCompanionTitle: 'Companion',
  mSignInPhoto: 'Sign In Photo',
  mSignInAt: 'Sign In Time',
  mSignInDevice: 'Sign In Device',
  mSignOutAt: 'Sign Out Time',
  mSignOutDevice: 'Sign Out Device',
  exportSuccess: 'Export successful!'
}

export default { zhCN, enUS }
